<script lang="ts">
	import { Button, Text } from '@Shelly/shelly-design-system';
	import { format } from 'svelte-i18n';
	import { openExternalLink } from 'src/helpers/utilities';

	/** Default promotions empty state — shop CTA on a primary→white gradient with tilted Shelly mark. */
	export let compact = false;

	const SHELLY_SHOP_URL = 'https://www.shelly.com/collections/all-products';
	const LOGO_SRC = '/images/shelly-logo.svg';

	const openShop = () => {
		openExternalLink(SHELLY_SHOP_URL);
	};
</script>

<div
	class="promo-empty"
	class:promo-empty--compact={compact}
	role="region"
	aria-label={$format('heading_promotions', { default: 'Promotions' })}
>
	<div class="promo-empty__gradient" aria-hidden="true"></div>
	<img class="promo-empty__logo" src={LOGO_SRC} alt="" aria-hidden="true" />
	<div class="promo-empty__content">
		{#if !compact}
			<Text styleType="body-small" class="promo-empty__copy text-600">
				{$format('text_discover_shelly_products', {
					default: 'Discover and buy Shelly products.',
				})}
			</Text>
		{/if}
		<Button size={compact ? 's' : 'm'} variant="primary" on:click={openShop}>
			{$format('text_open_shelly_shop', {
				default: 'Open Shelly shop',
			})}
		</Button>
	</div>
</div>

<style>
	.promo-empty {
		position: relative;
		width: 100%;
		height: 100%;
		min-height: 180px;
		max-height: 180px;
		overflow: hidden;
		isolation: isolate;
		box-sizing: border-box;
	}

	.promo-empty--compact {
		min-height: 120px;
		max-height: 120px;
	}

	/*
	 * Gradient opposite the logo tilt: logo is ~-38deg (up-left diagonal),
	 * so the fill runs ~142deg (primary → white).
	 */
	.promo-empty__gradient {
		position: absolute;
		inset: 0;
		z-index: 0;
		background: linear-gradient(
			142deg,
			var(--color-primary) 0%,
			var(--color-primary) 18%,
			#ffffff 78%,
			#ffffff 100%
		);
	}

	.promo-empty__logo {
		position: absolute;
		z-index: 1;
		width: 160%;
		max-width: none;
		left: -28%;
		top: -42%;
		transform: rotate(-38deg);
		opacity: 0.22;
		pointer-events: none;
		user-select: none;
	}

	.promo-empty__content {
		position: relative;
		z-index: 2;
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: flex-start;
		gap: 10px;
		height: 100%;
		padding: 16px;
		box-sizing: border-box;
	}

	.promo-empty--compact .promo-empty__content {
		padding: 10px 12px;
		gap: 6px;
	}

	.promo-empty--compact .promo-empty__logo {
		width: 140%;
		left: -22%;
		top: -48%;
		opacity: 0.18;
	}

	:global(.promo-empty__copy) {
		color: rgba(0, 0, 0, 0.72) !important;
		max-width: 70%;
		margin: 0;
	}
</style>
